// extracted by mini-css-extract-plugin
var _1 = "DzKQW";
var _2 = "ebDG6";
export { _1 as "activeTabOffset", _2 as "indicatorIcon" }
